module.exports = __webpack_public_path__ + "img/hero-main-2.88252904.png";